import CompanyPropertyDetailContent from "../../features/companyProperties/widgets/CompanyPropertyDetailContent";

function CompanyPropertyDetailScreen() {
  return <CompanyPropertyDetailContent />;
}

export default CompanyPropertyDetailScreen;
